import { createRouter, createWebHistory } from 'vue-router';
import Login from './components/login.vue';
import ForgotPassword from './components/forgot-password.vue';
import Dashboard from './components/dashboard.vue';

const routes = [
	{ path: '/login', component: Login },
	{ path: '/forgot-password', component: ForgotPassword },
	{ path: '/dashboard', component: Dashboard },
	{ path: '/:pathMatch(.*)*', redirect: '/login' },
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	const isAuthenticated = !!sessionStorage.getItem('token');
	if (to.path === '/dashboard' && !isAuthenticated) {
		next('/login');
	} else if (to.path === '/login' && isAuthenticated) {
		next('/dashboard');
	} else {
		next();
	}
});

export default router;
